// ─── Pas d'incrément des quantités ────────────────────────────────
// Module pur (aucun import React/Firebase) : la règle de départ du pas est
// testable sans monter l'interface.

// Unités « fines » : on y compte par dizaines (250 g, 500 ml), pas à l'unité.
const UNITE_FINE = /^(m?g|gr|grammes?|ml|cl|mL)$/i;

// Le pas est CHOISI par l'utilisateur, mais son point de départ est deviné :
// quand tout est en grammes ou en millilitres, commencer à 1 obligerait à
// changer le pas dès le premier ajustement. Dès qu'une ligne se compte à la
// pièce (« 2 boîtes »), on revient à 1 : mieux vaut un pas trop fin qu'un pas
// qui fait bondir une quantité de 1 à 11.
export const pasInitial = (lignes = []) => {
  // `|| []` en plus du défaut : celui-ci ne couvre que `undefined`, or un
  // appelant qui n'a pas encore chargé ses lignes passe `null`.
  const unites = (lignes || []).map(x => String(x?.unite || '').trim()).filter(Boolean);
  return unites.length > 0 && unites.every(u => UNITE_FINE.test(u)) ? 10 : 1;
};

// 1 → 10 → 100 → 1. Toute autre valeur retombe sur 1 (pas de cul-de-sac).
export const pasSuivant = (p) => (p === 1 ? 10 : p === 10 ? 100 : 1);
